// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle_switch__1REZx","slider":"Toggle_slider__1LZC4","round":"Toggle_round__2L0OR"};